export default __webpack_public_path__ + "static/media/hover4.c13c3030.png";